import * as React from "react";
const SvgFiRrHammer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hammer_svg__a)">
      <path
        fill="#062147"
        d="m23.141 9.794-7.127-7.202C12.848-.536 9.634-.168 7.992.33a2 2 0 0 0-1.37 1.447 1.98 1.98 0 0 0 .538 1.896l4.481 4.506L.863 18.892a3.005 3.005 0 0 0 .026 4.241c.565.56 1.313.867 2.108.867h.018a2.97 2.97 0 0 0 2.11-.886l10.747-10.68 2.285 2.297a2.98 2.98 0 0 0 2.13.887h.004a2.97 2.97 0 0 0 2.13-.892l.712-.72a3.016 3.016 0 0 0 .008-4.212M8.575 2.244a5.6 5.6 0 0 1 1.634-.249c1.29 0 2.83.468 4.391 2.011l4.964 5.017-2.128 2.147-8.862-8.91zM3.71 21.701a1 1 0 0 1-.704.298c-.277-.016-.519-.1-.709-.29a1 1 0 0 1-.016-1.407L13.052 9.597l1.41 1.418zM21.711 12.6l-.714.722a.99.99 0 0 1-.709.297h-.002a.99.99 0 0 1-.71-.296l-.73-.734 2.125-2.143.744.752a1.005 1.005 0 0 1-.004 1.402"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hammer_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHammer;
